import {
  Swiper
} from '../../../../../node_modules/swiper/swiper-bundle.esm';

export default class CustomSwiper {
  constructor(selector, settings) {
    return new Swiper(selector, settings);
  }
}
